import { Group, Vector3 } from "three";
import { latLonToLocal } from "./geo";
import { createChateauFrontenacModel } from "./props/createChateauFrontenacModel";
import { createPorteSaintLouisModel } from "./props/createPorteSaintLouisModel";
import { createTerrasseDufferinModel } from "./props/createTerrasseDufferinModel";
import { HUNT_STOPS } from "./stops";

export type HeroPlacement = {
  id: string;
  group: Group;
};

type HeroSpec = {
  id: string;
  create: () => Group;
  rotationY: number;
  scale?: number;
  /** World-space ENU nudge after rotation (meters) — register vs Google tiles AABB. */
  worldOffset?: [number, number, number];
};

const HERO_SPECS: HeroSpec[] = [
  {
    id: "chateau-frontenac",
    create: createChateauFrontenacModel,
    // Model +Z = Place d’Armes face. World SSE onto plaza (Google tiles / Cap Diamant).
    // Math.PI * 0.15 pointed forecourt at Terrasse (~187° wrong).
    rotationY: Math.PI + 0.344,
    // After rotation: shift masonry centroid onto OSM/tile mass (not local pivot fudge).
    worldOffset: [14, 0, -29],
  },
  {
    id: "porte-saint-louis",
    create: createPorteSaintLouisModel,
    // Gate faces Grande Allée approach
    rotationY: Math.PI * 0.55,
  },
  {
    id: "terrasse-dufferin",
    create: createTerrasseDufferinModel,
    // Boardwalk along cliff edge
    rotationY: Math.PI * -0.2,
    scale: 1.05,
  },
];

/** Place owned hero props on the twin (img2threejs-style factories). */
export function placeHeroProps(): HeroPlacement[] {
  const placed: HeroPlacement[] = [];
  for (const spec of HERO_SPECS) {
    const stop = HUNT_STOPS.find((s) => s.id === spec.id);
    if (!stop) continue;
    const model = spec.create();
    const pos = latLonToLocal(stop.lat, stop.lon, 0);
    model.position.copy(pos);
    model.rotation.y = spec.rotationY;
    model.scale.setScalar(spec.scale ?? 1);
    if (spec.worldOffset) {
      model.position.add(new Vector3(...spec.worldOffset));
    }
    placed.push({ id: spec.id, group: model });
  }
  return placed;
}
